import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const Explain = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 4.4a.6.6 0 0 1 .6.6v4.4a.6.6 0 0 1-1.2 0V7a.6.6 0 0 1 .6-.6zM8 4a.7.7 0 1 1 0 1.4A.7.7 0 0 1 8 4z"/>
      </svg>)} {...props}/>));
export default Explain;
